// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-container[data-v-15ca4e8e]{\n\ttext-align:left;\n\tpadding:20px 20px;\n}\n.modal-container p[data-v-15ca4e8e]{\n\tline-height:25px;\n}\n", ""]);
// Exports
module.exports = exports;
